import DepartmentsModel from '../models/DepartmentsModel';

export default class DepartmentsCollection extends Backbone.Collection {
  constructor(options) {
    super(options);
    this.model = DepartmentsModel;
  }

  parse(response) {
    return response.data; 
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_DEPARTMENT:
        let deptID = payload.postData[Utils.getEndpointParam('DEPARTMENT_ID_PARAM')];
        const department = DepartmentsStore.getDepartmentById(deptID);
        if (!_.isEmpty(department)) {
          DepartmentsStore.trigger('load:success', department, department, payload.postData.target);
        } else {
          Utils.setMakeshiftTokenHeader();

          let deptURL =
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
            appConstants.ApiPaths.API_VERSION_PATH +
            appConstants.EndPoints.GET_DEPARTMENTS;

          deptURL = deptURL.replace('%d', deptID);
          DepartmentsStore.fetch({
            traditional: true,
            data: { target: payload.postData.target },
            url: deptURL,
            type: 'GET',
            success: DepartmentsStore.onDepartmentHandler,
            fail: DepartmentsStore.onDepartmentError,
          });
        }
        break;
      case ActionTypes.GET_DEPARTMENT_SCHEDULE:
        const startParam = Utils.getEndpointParam('START_PARAM');
        const endParam = Utils.getEndpointParam('END_PARAM');

        deptID = payload.postData[Utils.getEndpointParam('DEPARTMENT_ID_PARAM')];
        const start = payload.postData[startParam];
        const end = payload.postData[endParam];
        
        Utils.setMakeshiftTokenHeader();
        let deptScheduleURL = `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV}${appConstants.ApiPaths.API_VERSION_PATH}${appConstants.EndPoints.DEPARTMENTS_SCHEDULE_PATH}?${startParam}=${start}&${endParam}=${end}`;
        deptScheduleURL = deptScheduleURL.replace('%d', deptID);
        
        DepartmentsStore.fetch({
          traditional: true,
          url: deptScheduleURL,
          type: 'GET',
          success: DepartmentsStore.onDepartmentScheduleHandler,
          fail: DepartmentsStore.onDepartmentScheduleError,
        });
        break;
    }
  }
}
